import { FormControl } from "@material-ui/core";
import _ from "lodash";
import React, { useCallback, useMemo } from 'react';
import Select from "react-select";
import { Asset } from "../../../../../api/api";
import { RP } from "../transfers/TransfersTable";

export interface WithAsset {
  asset: number
}

export interface DataSet {
  [key: string]: string
}

export interface AssetFilterSelectorProps<T extends {}> extends RP<T> {
  dataSet: DataSet
}

const getAssetByName = (dataSet: DataSet, assetName: string): any => {
  return Object.keys(dataSet).find(key => dataSet[key] === assetName)
}

export function AssetFilterSelector<T extends {}>(p: AssetFilterSelectorProps<T>) {
  const {columnDef, onFilterChanged, dataSet} = p;
  // @ts-ignore
  const value = columnDef.tableData.filterValue || getAssetByName(dataSet, 'USD')
  // @ts-ignore
  const id: string = useMemo(() => columnDef.tableData.id, [columnDef])

  const onChange = useCallback( (value, actionMeta) => {
    onFilterChanged(id, (value == null)? null: value['value'])
  }, [id, onFilterChanged])

  let options: {}[] = Object.entries(dataSet).map(
    (key, value) => {
      return {
        label: key[1],
        value: key[0]
      }
    }
  )
  return (
    <>
      <FormControl style={{ width: '100%' }}>
        <Select
          defaultValue={value}
          options={options}
          isSearchable={true}
          isClearable={true}
          onChange={onChange}
        />
      </FormControl>
    </>
  );
}

export function makeFilterSelector<T extends {}>(assets?: Asset[]) {
  const dataSet = _.chain(assets)
    .filter((a: Asset) => a.id < 9999 || (a.id >= 23000 && a.id <= 23999))
    .map((a: Asset) => [a.id, a.ticker])
    .fromPairs()
    .value()
  return (p: RP<T>) => <AssetFilterSelector {...p} dataSet={dataSet} />
}

export const AssetViewCell = (assets?: Asset[]) => (data: WithAsset, type: ('row' | 'group')) => {
  const ticker = _.find(assets, a => a.id === data.asset)?.ticker || '';
  return (
    <>{ticker}</>
  )
}
